// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}
*::before, *::after {
  box-sizing: border-box;
}

.container {
  margin: 0 auto;
  padding: 10px 10px 10px 10px;
  width: 100% !important;
}

body {
  margin: 0;
  padding: 0;
  background: #fff;
  display: flex;
  min-height: 100vh;
}

.accordion h3 {
  text-align: center;
}
.accordion .accordion-title {
  font-size: 16px;
  padding-left: 10px;
}
.accordion button {
  position: relative;
  display: flex;
  justify-content: space-between;
  text-align: left;
  width: 100%;
  padding: 1em 0;
  border: none;
  background: none;
  outline: none;
  transition: background-color 0.4s ease;
}
.accordion button:hover, .accordion button:focus {
  cursor: pointer;
  background-color: rgba(204, 204, 204, 0.7);
}
.accordion button:hover::after, .accordion button:focus::after {
  cursor: pointer;
  background-color: rgba(204, 204, 204, 0.7);
}
.accordion button .icon {
  display: inline-block;
  position: absolute;
  top: 10px;
  right: 0;
  width: 22px;
  height: 22px;
  border-radius: 22px;
}
.accordion button .icon::before {
  display: block;
  position: absolute;
  content: "";
  top: 9px;
  left: 5px;
  width: 10px;
  height: 2px;
  background: currentColor;
}
.accordion button .icon::after {
  display: block;
  position: absolute;
  content: "";
  top: 5px;
  left: 9px;
  width: 2px;
  height: 10px;
  background: currentColor;
}
.accordion button[aria-expanded=true] .icon::after {
  width: 0;
}
.accordion button[aria-expanded=true] + .accordion-content {
  opacity: 1;
  max-height: 500px;
  transition: all 500ms linear;
  will-change: opacity, max-height;
}
.accordion .accordion-content {
  opacity: 0;
  max-height: 0;
  padding-left: 10px;
  overflow: hidden;
  transition: opacity 500ms linear, max-height 500ms linear;
  will-change: opacity, max-height;
}
.accordion .accordion-content p {
  padding: 10px 5px 10px 20px;
  transition: background-color 0.2s ease;
}
.accordion .accordion-content p:focus, .accordion .accordion-content p:hover {
  background-color: #bcbcbc;
  cursor: pointer;
}
.accordion .accordion-content p:focus .icon-chevron-down, .accordion .accordion-content p:hover .icon-chevron-down {
  animation: moveLeftRight 0.5s 2;
}
.accordion .accordion-content p.question-type {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.accordion .accordion-content p.question-type .icon-chevron-down {
  margin-right: 15px;
}
.accordion .accordion-content p.question-type .question-text {
  margin-right: 10px;
  flex-grow: 1;
  width: 90%;
}

.icon-chevron-down {
  width: 13px;
  margin-right: 15px;
  transform: rotate(-90deg);
  transition: transform 0.3s ease-in-out;
}

@keyframes moveLeftRight {
  0% {
    transform: translateX(0) rotate(-90deg);
  }
  50% {
    transform: translateX(10px) rotate(-90deg);
  }
  100% {
    transform: translateX(0) rotate(-90deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/people/components/web/people-assistant-modal/people-assistant-modal-questions/people-assistant-modal-questions.component.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;AACJ;AAAI;EAEI,sBAAA;AACR;;AAEA;EACI,cAAA;EACA,4BAAA;EACA,sBAAA;AACJ;;AAEA;EACI,SAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;AACJ;;AAGI;EACI,kBAAA;AAAR;AAEI;EACI,eAAA;EACA,kBAAA;AAAR;AAEI;EACI,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sCAAA;AAAR;AACQ;EAEI,eAAA;EACA,0CAAA;AAAZ;AACY;EACI,eAAA;EACA,0CAAA;AAChB;AAGQ;EACI,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AADZ;AAEY;EACI,cAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;AAAhB;AAEY;EACI,cAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,wBAAA;AAAhB;AAMY;EACI,QAAA;AAJhB;AAOQ;EACI,UAAA;EACA,iBAAA;EACA,4BAAA;EACA,gCAAA;AALZ;AAQI;EACI,UAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yDAAA;EACA,gCAAA;AANR;AAOQ;EACI,2BAAA;EACA,sCAAA;AALZ;AAMY;EAEI,yBAAA;EACA,eAAA;AALhB;AAMgB;EACI,+BAAA;AAJpB;AAOY;EACI,aAAA;EACA,2BAAA;EACA,mBAAA;AALhB;AAMgB;EACI,kBAAA;AAJpB;AAMgB;EACI,kBAAA;EACA,YAAA;EACA,UAAA;AAJpB;;AAWA;EACI,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,sCAAA;AARJ;;AAWA;EACI;IACI,uCAAA;EARN;EAUE;IACI,0CAAA;EARN;EAUE;IACI,uCAAA;EARN;AACF","sourcesContent":["* {\n    box-sizing: border-box;\n    &::before,\n    &::after {\n        box-sizing: border-box;\n    }\n}\n.container {\n    margin: 0 auto;\n    padding: 10px 10px 10px 10px;\n    width: 100% !important;\n}\n\nbody {\n    margin: 0;\n    padding: 0;\n    background: #fff;\n    display: flex;\n    min-height: 100vh;\n}\n\n.accordion {\n    h3 {\n        text-align: center;\n    }\n    .accordion-title {\n        font-size: 16px;\n        padding-left: 10px;\n    }\n    button {\n        position: relative;\n        display: flex;\n        justify-content: space-between;\n        text-align: left;\n        width: 100%;\n        padding: 1em 0;\n        border: none;\n        background: none;\n        outline: none;\n        transition: background-color 0.4s ease;\n        &:hover,\n        &:focus {\n            cursor: pointer;\n            background-color: rgba(204, 204, 204, 0.7);\n            &::after {\n                cursor: pointer;\n                background-color: rgba(204, 204, 204, 0.7);\n            }\n        }\n\n        .icon {\n            display: inline-block;\n            position: absolute;\n            top: 10px;\n            right: 0;\n            width: 22px;\n            height: 22px;\n            border-radius: 22px;\n            &::before {\n                display: block;\n                position: absolute;\n                content: '';\n                top: 9px;\n                left: 5px;\n                width: 10px;\n                height: 2px;\n                background: currentColor;\n            }\n            &::after {\n                display: block;\n                position: absolute;\n                content: '';\n                top: 5px;\n                left: 9px;\n                width: 2px;\n                height: 10px;\n                background: currentColor;\n            }\n        }\n    }\n    button[aria-expanded='true'] {\n        .icon {\n            &::after {\n                width: 0;\n            }\n        }\n        + .accordion-content {\n            opacity: 1;\n            max-height: 500px;\n            transition: all 500ms linear;\n            will-change: opacity, max-height;\n        }\n    }\n    .accordion-content {\n        opacity: 0;\n        max-height: 0;\n        padding-left: 10px;\n        overflow: hidden;\n        transition: opacity 500ms linear, max-height 500ms linear;\n        will-change: opacity, max-height;\n        p {\n            padding: 10px 5px 10px 20px;\n            transition: background-color 0.2s ease;\n            &:focus,\n            &:hover {\n                background-color: #bcbcbc;\n                cursor: pointer;\n                .icon-chevron-down {\n                    animation: moveLeftRight 0.5s 2;\n                }\n            }\n            &.question-type {\n                display: flex;\n                justify-content: flex-start;\n                align-items: center;\n                .icon-chevron-down {\n                    margin-right: 15px;\n                }\n                .question-text {\n                    margin-right: 10px;\n                    flex-grow: 1;\n                    width: 90%;\n                }\n            }\n        }\n    }\n}\n\n.icon-chevron-down {\n    width: 13px;\n    margin-right: 15px;\n    transform: rotate(-90deg);\n    transition: transform 0.3s ease-in-out;\n}\n\n@keyframes moveLeftRight {\n    0% {\n        transform: translateX(0) rotate(-90deg);\n    }\n    50% {\n        transform: translateX(10px) rotate(-90deg);\n    }\n    100% {\n        transform: translateX(0) rotate(-90deg);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
